import { useState, useEffect } from 'react';
import get from 'lodash/get';
import { FFFStorage, Compare } from '@fff-web/fff-utilities';
import { getCouponContent } from '../services/redeem';

const couponContentKey = 'coupon-content';
const cacheDurationInMs = 10 * 60 * 1000; //10 minutes
const getKey = (coupon, screenKey) => `${couponContentKey}-${coupon}-${screenKey}`;
const useCouponContent = (screenKey) => {
  const [coupon, setCoupon] = useState('');
  const [couponContent, setCouponContent] = useState(
    FFFStorage.getFromStorage({ key: getKey(coupon, screenKey) }),
  );

  const getCouponContentKey = (key, defaultValue = '') => get(couponContent, key, defaultValue);

  const handleCouponChange = (couponApplied) => {
    setCoupon(couponApplied);
    refreshCouponContent(couponApplied);
  };
  const refreshCouponContent = (couponApplied) => {
    const contentCache = FFFStorage.getFromStorage({ key: getKey(couponApplied, screenKey) });

    if (contentCache) {
      if (!Compare.isEqualObject(couponContent, contentCache)) {
        setCouponContent(contentCache);
      }
    } else {
      getCouponContent(couponApplied, screenKey).then((data) => {
        const content = data.data;
        setCouponContent(content);
        FFFStorage.setToStorage({
          key: getKey(couponApplied, screenKey),
          value: content,
          durationInMs: cacheDurationInMs,
        });
      });
    }
  };

  useEffect(() => {
    refreshCouponContent(coupon);
  }, []);

  return { getCouponContentKey, handleCouponChange };
};

export default useCouponContent;
